import { useEffect, useState, useContext } from 'react';
import moment from 'moment';

import { getUserDetail, getInicisPayment } from '../modules/NetworkFunction';
import usePaymentStatus from '../hooks/usePaymentStatus';
import ShopModeContext from '../../src/contexts/ShopModeContext'


const AppStatusTable = ({ token }) => {
  const [userData, setUserData] = useState();

  const { isPaid, period } = usePaymentStatus(token);
  const { shopMode } = useContext(ShopModeContext);

  const [isInicisPaid, setIsInicisPaid] = useState(false);
  const [paymentInicisData, setPaymentInicisData] = useState();

  useEffect(() => {
    getUserDetail(
      null,
      (v) => {
        setUserData(v.user);
      },
      () => {},
      (e) => {
        console.log('getuserdetail', e);
      },
      token
    );
  }, [token]);

  useEffect(() => {
    getInicisPayment(
      {
        userNo: userData?.userNo
      },
      (v) => {
        console.log(v);
        if (v.payment.length > 0){
          setIsInicisPaid(true)
        } else {
          setIsInicisPaid(false)
        }
        setPaymentInicisData(v.payment[0]);
      },
      () => {},
      (error) => {
        console.error(error);
      },
      token
    )

  }, [userData, token])

  return (
    <div className="inner-box" style={{ margin: '53px 0' }}>
      <p className="subtitle">앱 이용 현황</p>
      <div
        style={{
          overflow: 'hidden',
          border: '1px solid #CCC',
          borderRadius: 5,
          width: 750,
          fontSize: 18,
        }}
      >
        <table>
          <tbody>
            <tr style={{ height: 50 }}>
              <td
                style={{
                  width: 237,
                  backgroundColor: '#f3f3f3',
                  textAlign: 'center',
                }}
              >
                앱 설치
              </td>
              <td style={{ width: 513, textAlign: 'center' }}>
                {userData &&
                  moment(userData.createDate).format('YYYY-MM-DD HH:mm')}
              </td>
            </tr>
            <tr style={{ height: 50 }}>
              <td
                style={{
                  backgroundColor: '#f3f3f3',
                  textAlign: 'center',
                }}
              >
                사용 중인 서비스
              </td>
              <td>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  {shopMode === 'cafe24' ? 
                  (isPaid ? '유료 버전' : '무료 버전') :
                  (isInicisPaid ? '유료 버전' : '무료 버전') }
                </div>
              </td>
            </tr>
            <tr style={{ height: 50 }}>
              <td
                style={{
                  backgroundColor: '#f3f3f3',
                  textAlign: 'center',
                }}
              >
                사용기간
              </td>
              <td>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  {shopMode === 'cafe24' ? 
                  (isPaid ? period : 'X') :
                  (isInicisPaid ? moment(paymentInicisData?.expirationDate).format('YYYY-MM-DD') : 'X')}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AppStatusTable;
